export default __webpack_public_path__ + "static/media/VerticalLineCard.1417d02b.svg";